import type { SupportedLocale } from "./datetime"

/**
 * The one money formatter (FR-DSH-XCT-06). Money is a whole number of XAF
 * (ISO 4217 exponent 0, DV-145): 25000 is twenty-five thousand francs, never
 * divided by 100.
 */
export function formatMoney(amount: number, locale: SupportedLocale): string {
  return new Intl.NumberFormat(locale === "fr" ? "fr-FR" : "en-GB", {
    style: "currency",
    currency: "XAF",
    maximumFractionDigits: 0,
  }).format(amount)
}

/** VAT exactly as backend money.VAT: (amount × rateBP + 5000) div 10000, half-up on the franc. */
export function vat(amount: number, rateBP: number): number {
  return Math.floor((amount * rateBP + 5_000) / 10_000)
}

export const totalWithVat = (amount: number, rateBP: number): number => amount + vat(amount, rateBP)

/** `n` calendar months on; the 31st becomes the month's last day when it has fewer (valid-until preview). */
export function addMonths(d: Date, n: number): Date {
  const out = new Date(d.getFullYear(), d.getMonth() + n, 1, d.getHours(), d.getMinutes(), d.getSeconds())
  const last = new Date(out.getFullYear(), out.getMonth() + 1, 0).getDate()
  out.setDate(Math.min(d.getDate(), last))
  return out
}
